<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row class="row pt-5">
        <v-col class="mt-sm-20" m="12" md="7" lg="7">
          <div>
            <h2>
              <b>Simplify, Secure, and Streamline Your Document Workflows</b>
            </h2>
            <br />
            Are you overwhelmed by excessive documents in SharePoint without
            proper control? Our Secure Private Document Management System with
            eSign Capability ensures seamless access, security, and compliance,
            allowing your team to manage, sign, and track documents
            effortlessly.
            <br /><br />
            With attribute-based rights management and Single Sign-On (SSO)
            integration, access control is automated based on user roles and
            attributes, ensuring only authorized personnel can view or sign
            critical documents.
            <br />
          </div>

          <div>
            <h2 class="pt-5">Key Features</h2>
            <v-row align="top" no-gutters class="pt-4">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-file-sign</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Customizable eSign Workflows</p>
                <p class="description">
                  Tailor signing processes to your organization's needs.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-lock-check</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Attribute-Based Access Control</p>
                <p class="description">
                  Secure documents with user-specific permissions.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-account-key</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">SSO Integration</p>
                <p class="description">
                  Simplify authentication with existing enterprise logins.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-database-sync</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Multiple Backup & Redundancy</p>
                <p class="description">
                  Ensure continuous availability and data protection.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-microsoft-sharepoint</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Seamless SharePoint Integration</p>
                <p class="description">
                  Sync, store, and manage documents effortlessly.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-file-search</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Audit Trails & Compliance</p>
                <p class="description">
                  Maintain transparency with detailed document logs.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-cellphone-link</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Mobile & Web Access</p>
                <p class="description">
                  Sign and manage documents from anywhere.
                </p>
              </v-col>
            </v-row>

            <v-row align="top" no-gutters class="pt-3">
              <v-col cols="auto">
                <v-icon large color="#1976d2" class="icon-background"
                  >mdi-bell-ring</v-icon
                >
              </v-col>
              <v-col class="pl-5">
                <p class="title">Automated Notifications & Reminders</p>
                <p class="description">
                  Keep signers and approvers informed.
                </p>
              </v-col>
            </v-row>
          </div>

          <div class="pt-5">
            <div><h2 class="pt-5 pb-4">How It Works</h2></div>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large>mdi-numeric-1-circle </v-icon
              >&nbsp;
              <span class="sicon"
                ><b>Upload & Store - </b> Securely organize and categorize your
                documents.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-numeric-2-circle </v-icon
              >&nbsp;
              <span class="sicon"
                ><b>Set Permissions - </b>Use attribute-based rights to control
                document access.</span
              >
            </v-col>

            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-numeric-3-circle </v-icon
              >&nbsp;
              <span class="sicon"
                ><b>Initiate eSignatures - </b>Create workflows for approvals
                and signatures.</span
              >
            </v-col>

            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-numeric-4-circle </v-icon
              >&nbsp;
              <span class="sicon"
                ><b>Track & Monitor - </b>Get real-time status updates and
                compliance reports.</span
              >
            </v-col>
          </div>

          <div class="pt-5">
            <div><h2 class="pt-5 pb-4">Why Choose Us?</h2></div>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-shield-lock </v-icon>&nbsp;
              <span class="sicon"
                ><b>Security First - </b>Advanced encryption and secure backups
                protect your data.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-link-variant</v-icon>&nbsp;
              <span class="sicon"
                ><b>Seamless Integration - </b>Works effortlessly with
                SharePoint and enterprise systems.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-resize </v-icon>&nbsp;
              <span class="sicon"
                ><b>Scalable & Customizable - </b>Adapts to businesses of all
                sizes.</span
              >
            </v-col>
            <v-col cols="auto">
              <v-icon color="#1976d2" x-large> mdi-shield-check </v-icon>&nbsp;
              <span class="sicon"
                ><b>Efficiency & Compliance - </b>Automate workflows while
                maintaining full control.</span
              >
            </v-col>
          </div>

          <div class="pt-5">
            <h3>Get Started Today!</h3>
            <p class="pt-2">
              Experience secure, efficient, and fully controlled document
              management with built-in eSign capability.
            </p>
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Secure Private Document Management with eSign Capability";
  }
};
</script>

<style scoped>
.row {
  text-align: justify;
}
/* h3 {
    font-size: 20px;
    color: #033261;
  } */

.icon-background {
  background-color: #c4e1f8;
  border-radius: 50%;
  padding: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  color: #080808;
  font-weight: bold;
  margin: 0;
}

.description {
  color: #333333;
  margin: 0;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
